import React, { Component } from "react";
import Slider from "../components/Slider";
import Nav from "../components/Nav";
import Intro from "../components/Intro";
import Projects from "../components/Projects";
import Footer from "../components/Footer";

// digest imports
import Digest from "../components/Digest";
import { DigestOne } from "../components/Digest/data";

// skills imports
import Skills from "../components/Skills";
import { Skillset } from "../components/Skills/data";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.toggleSlider = this.toggleSlider.bind(this);
  }
  toggleSlider() {
    this.setState({ isOpen: !this.state.isOpen });
  }
  render() {
    return (
      <>
        <Slider isOpen={this.state.isOpen} toggleSlider={this.toggleSlider} />
        <Nav toggleSlider={this.toggleSlider} />
        <Intro />
        <Digest {...DigestOne} />
        <Skills {...Skillset} />
        <Projects />
        <Footer />
      </>
    );
  }
}

export default Home;
